import { create } from 'zustand';

import type { TAppVersionStatus } from '@shared/utils/app-version';

/**
 * Whether this tab is behind the deployed build. Written by `AppVersionCheck` (the only poller) and
 * read by the banner and the layout, so they never disagree and the manifest is fetched once, not per
 * reader. Not persisted: it describes this tab's build, which a reload replaces.
 */
interface IAppVersionState {
  status: TAppVersionStatus;
  /** The deployed build the last check saw. 0 until a check succeeds. */
  latestVersion: number;
  /** The deployed build whose banner the operator closed. A newer build shows the banner again. */
  dismissedVersion: number;
  setResult: (status: TAppVersionStatus, latestVersion: number) => void;
  dismiss: () => void;
}

export const useAppVersionStore = create<IAppVersionState>((set) => ({
  status: 'disabled',
  latestVersion: 0,
  dismissedVersion: 0,
  setResult: (status, latestVersion) => set({ status, latestVersion }),
  dismiss: () => set((state) => ({ dismissedVersion: state.latestVersion })),
}));

/** The "new version available" banner shows: a newer build exists and it was not dismissed. */
export const useIsAppVersionBannerVisible = () =>
  useAppVersionStore(
    (state) => state.status === 'update_available' && state.latestVersion > state.dismissedVersion
  );
